<template>
  <!-- <Block class="w-3/4"> -->
  <Block chart class="w-full overflow-hidden">
    <div class="flex flex-col w-full gap-5">
      <div class="flex items-start justify-between p-5">
        <ChartHeader
          img="/apple-icon-180x180.png"
          :title="`${tokenSymbol} Price`"
          :amount="`$${tokenPriceUSDFormatted}`"
        />
      </div>
      <LineChart
        :chartData="chartData"
        :options="chartOptions"
        :width="250"
        :height="250"
      />
    </div>
  </Block>
</template>

<script>
import { mapGetters } from "vuex";
import { LineChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
import Block from "../global/Block.vue";
import ChartHeader from "./ChartHeader.vue";
Chart.register(...registerables);
export default {
  name: "PlatformRevenueChart",
  components: {
    LineChart,
    Block,
    ChartHeader,
  },
  computed: {
    ...mapGetters([
      "hypeChartData",
      "tokenPriceUSDFormatted",
      "tokenSymbol",
    ]),

    chartData() {
      return {
        labels:
          this.hypeChartData &&
          this.hypeChartData.map((label) => {
            return label[0];
          }),
        datasets: [
          {
            data:
              this.hypeChartData &&
              this.hypeChartData.map((price) => {
                return price[1];
              }),
            // borderColor: "#22c55e",
            borderColor: (context) => {
              const chart = context.chart;
              const { ctx, chartArea } = chart;

              if (!chartArea) {
                // This case happens on initial chart load
                return;
              }
              return this.getGradient(ctx, chartArea);
            },
            fill: true,
            backgroundColor: "black",
            pointRadius: 0,
            lineTension: 0.4,
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            display: false,
          },
          y: {
            display: false,
          },
        },
      };
    },
  },
  methods: {
    getGradient(ctx, chartArea) {
      let width, height, gradient;
      const chartWidth = chartArea.right - chartArea.left;
      const chartHeight = chartArea.bottom - chartArea.top;
      if (
        !gradient ||
        width !== chartWidth ||
        height !== chartHeight
      ) {
        // Create the gradient because this is either the first render
        // or the size of the chart has changed
        width = chartWidth;
        height = chartHeight;
        gradient = ctx.createLinearGradient(
          0,
          chartArea.bottom,
          0,
          chartArea.top
        );
        gradient.addColorStop(0, "#652DE8");
        gradient.addColorStop(0.5, "#3981FC");
        gradient.addColorStop(1, "#00DAEE");
      }
      return gradient;
    },
  },
};
</script>
